```vue
<template>
  <div ref="menuContainer">
    <div class="relative tw-justify-center mb-6 text-white">
      <div :class="mainDomain === 'meirelesleiloes' ? 'container_filter-meireles' : 'container_filter'" class=""
           id="scroll-here">
        <div class="search-container">
          <div class="search-box">
            <div class="search-input-container">
              <div class="input-wrapper">
                <input @keyup.enter="filterLotes" v-model="search" class="search-input" placeholder="busca livre"/>
                <i v-if="search" class="icon-close" @click="clearFilters"></i>
              </div>
            </div>
            <div class="filters-container">
              <div class="filter-group">
                <div class="filter" @click="showFilter('tipo')">
                  <div class="filter-title">tipo
                    <i v-if="collapse.tipo" class="icon-arrow-up"></i>
                    <i v-else class="icon-arrow-down"></i>
                  </div>
                  <div class="filter-menu" id="filter-menu-tipo" v-show="collapse.tipo" @click.stop>
                    <div class="filter-options">
                      <label v-for="(tipo, idx) in filterTipos" class="filter-option" :key="idx">
                        <input v-model="tipos" type="checkbox" class="checkbox" :value="tipo"/>
                        {{ tipo }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="filter" @click="showFilter('categoria')" :class="{ 'disabled': !tipos.length }">
                  <div class="filter-title">categoria
                    <i v-if="collapse.categoria" class="icon-arrow-up"></i>
                    <i v-else class="icon-arrow-down"></i>
                  </div>
                  <div class="filter-menu" id="filter-menu-categoria" v-show="collapse.categoria && tipos.length"
                       @click.stop>
                    <div class="filter-options">
                      <label v-for="(categoria, idx) in filterCategorias" :key="idx" class="filter-option">
                        <input v-model="categorias" type="checkbox" class="checkbox" :value="categoria"/>
                        {{ categoria }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="filter-group">
                <div class="filter" @click="showFilter('estado')">
                  <div class="filter-title">estado
                    <i v-if="collapse.estado" class="icon-arrow-up"></i>
                    <i v-else class="icon-arrow-down"></i>
                  </div>
                  <div class="filter-menu" id="filter-menu-estado" v-show="collapse.estado" @click.stop>
                    <div class="filter-options">
                      <label v-for="(estado, idx) in estadosFiltrados" :key="idx" class="filter-option">
                        <input v-model="estados" type="checkbox" class="checkbox" :value="estado"/>
                        {{ estado }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="filter" @click="showFilter('cidade')" :class="{ 'disabled': !estados.length }">
                  <div class="filter-title">cidade
                    <i v-if="collapse.cidade" class="icon-arrow-up"></i>
                    <i v-else class="icon-arrow-down"></i>
                  </div>
                  <div class="filter-menu" id="filter-menu-cidade" v-show="collapse.cidade && estados.length"
                       @click.stop>
                    <div class="filter-options">
                      <label v-for="(cidade, idx) in cidadesFiltradas" :key="idx" class="filter-option">
                        <input v-model="cidades" type="checkbox" class="checkbox" :value="cidade"/>
                        {{ cidade }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="filter-group">
                <div class="filter-values" @click="showFilter('valores')">
                  <div class="filter-title">
                    <span class="filter-label">valores</span>
                    <i v-if="collapse.valores" class="icon-arrow-up"></i>
                    <i v-else class="icon-arrow-down"></i>
                  </div>
                  <div class="filter-menu-values" v-show="collapse.valores" @click.stop>
                    <div class="filter-values-container">
                      <div class="value-inputs">
                        <div class="value-input">
                          <label>Valor mín.</label>
                          <input v-model="valores.min" type="number" min="0" class="value-input-field"/>
                        </div>
                        <div class="value-separator">
                          <div class="separator-dot"></div>
                          <div class="separator-line"></div>
                          <div class="separator-dot"></div>
                        </div>
                        <div class="value-input">
                          <label>Valor máx.</label>
                          <input v-model="valores.max" type="number" min="0" class="value-input-field"/>
                        </div>
                      </div>
                      <div class="filter-button-container">
                        <button @click="filterLotes" class="filter-button">Filtrar</button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Filtro favoritos -->
                <div class="favorites-container">
                  <div @click="favoritos" class="favorites-icon" title="Filtrar Favoritos">
                    <span>favoritos</span>
                    <i class="cursor-pointer" :class="filterFavoritos ? 'icon-heart-o' : 'icon-heart'"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="filter-group">
            <div class="limpar-btn" @click="clearFilters">
              <span>limpar</span>
              <i class="icon-close"></i>
            </div>

            <p v-if="hasActiveFilters" class="filter-alert">
              Filtros aplicados! Clique no botão "limpar" para resetar os filtros.
            </p>

            <div class="buscar-btn"  @click="filterLotes">
              <span>pesquisar</span>
              <i class="icon-lupa"></i>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['leilao', 'filtros', 'iscategoria', 'loadfiltro', 'lotes', 'usuario'],
  data() {
    return {
      search: '',
      filterEstados: [],
      filterCidades: [],
      filterCategorias: [],
      filterTipos: [],
      filterFavoritos: false,
      cidades: [],
      estados: [],
      categorias: [],
      tipos: [],
      valores: {
        min: false,
        max: false,
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: true,
      },
      collapse: {
        tipo: false,
        categoria: false,
        estado: false,
        cidade: false,
        valores: false
      },
      showAlertMessage: false,
      cidadesPorEstado: {},
      categoriasPorTipo: {},
      estadosPorCategoria: {}
    }
  },
  computed: {
    hasActiveFilters() {
      return (
        this.search ||
        this.cidades.length ||
        this.estados.length ||
        this.categorias.length ||
        this.tipos.length ||
        this.valores.min ||
        this.valores.max ||
        this.filterFavoritos
      );
    },

    estadosFiltrados() {
      if (!this.tipos.length && !this.categorias.length) {
        return this.filterEstados;
      }

      let estadosDisponiveis = new Set();

      this.$parent.lotesOriginais.forEach(lote => {
        if (lote.vistoria && lote.vistoria.length > 0) {
          const vistoria = lote.vistoria[0];

          const matchTipo = !this.tipos.length || this.tipos.includes(vistoria.nm_categoria);
          const matchCategoria = !this.categorias.length || this.categorias.includes(vistoria.nm_subcategoria);

          if (matchTipo && matchCategoria) {
            if (vistoria.i_nm_estado) estadosDisponiveis.add(vistoria.i_nm_estado);
            if (vistoria.e_nm_estado) estadosDisponiveis.add(vistoria.e_nm_estado);
            if (vistoria.v_nm_estado) estadosDisponiveis.add(vistoria.v_nm_estado);
          }
        }
      });

      return Array.from(estadosDisponiveis).sort();
    },

    cidadesFiltradas() {
      if (!this.estados.length) return [];

      let cidadesDisponiveis = new Set();

      this.$parent.lotesOriginais.forEach(lote => {
        if (lote.vistoria && lote.vistoria.length > 0) {
          const vistoria = lote.vistoria[0];

          const matchTipo = !this.tipos.length || this.tipos.includes(vistoria.nm_categoria);
          const matchCategoria = !this.categorias.length || this.categorias.includes(vistoria.nm_subcategoria);

          if (matchTipo && matchCategoria) {
            if (this.estados.includes(vistoria.i_nm_estado)) {
              cidadesDisponiveis.add(vistoria.i_nm_cidade);
            }
            if (this.estados.includes(vistoria.e_nm_estado)) {
              cidadesDisponiveis.add(vistoria.e_nm_cidade);
            }
            if (this.estados.includes(vistoria.v_nm_estado)) {
              cidadesDisponiveis.add(vistoria.v_nm_cidade);
            }
          }
        }
      });

      return Array.from(cidadesDisponiveis).sort();
    },

    mainDomain() {
      if (typeof window === 'undefined') return '';

      const domainParts = window.location.hostname.split('.');

      if ((domainParts[0] === 'dev' || domainParts[0] === 'teste') && domainParts[1] !== 'vue') {
        return domainParts[1];
      }
      if (domainParts[0] === 'dev' && domainParts[1] === 'vue') {
        return domainParts[2];
      }
      if (domainParts[0] === 'www') {
        return domainParts[1];
      }

      return domainParts[0];
    },
  },
  watch: {
    tipos: {
      handler() {
        this.categorias = [];
        this.estados = [];
        this.cidades = [];
        this.atualizarCategoriasPorTipo();
      },
      deep: true
    },
    categorias: {
      handler() {
        this.estados = [];
        this.cidades = [];
      }
    },
    estados: {
      handler() {
        this.cidades = [];
      }
    }
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    sessionStorage.removeItem('filtro-saladisputa');

    this.$nextTick(() => {
      this.atualizarCidadesPorEstado();
      this.atualizarCategoriasPorTipo();
      this.atualizarEstadosPorCategoria();

      const filtrosSalvos = sessionStorage.getItem('filtro-saladisputa');

      const esperarLotes = () => {
        if (this.$parent.lotes && this.$parent.lotes.length) {
          if (filtrosSalvos) {
            const filtros = JSON.parse(filtrosSalvos);
            this.search = filtros.search || '';
            this.tipos = filtros.tipos || [];
            this.categorias = filtros.categorias || [];
            this.estados = filtros.estados || [];
            this.cidades = filtros.cidades || [];
            this.valores = filtros.valores || {min: '', max: ''};
            this.filterFavoritos = filtros.filterFavoritos || false;
          }

          this.setFilters();
          this.aplicarFiltrosNosLotes();
        } else {
          setTimeout(esperarLotes, 100);
        }
      };

      if (filtrosSalvos) {
        this.$parent.saladisputa.refreshLotesListagem(false, 1, () => {
          esperarLotes();
        });
      } else {
        esperarLotes();
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    ordenarLotesPorSequencia(lotes) {
      return [...lotes].sort((a, b) => {
        return parseInt(a.seq) - parseInt(b.seq);
      });
    },

    normalizarTexto(texto) {
      if (!texto) return '';

      return texto
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s\.\-]/g, '')
        .trim();
    },

    showFilter(collapseID) {
      if ((collapseID === 'categoria' && !this.tipos.length) ||
        (collapseID === 'cidade' && !this.estados.length)) {
        return;
      }

      for (const key in this.collapse) {
        if (key !== collapseID) this.collapse[key] = false;
      }
      this.collapse[collapseID] = !this.collapse[collapseID];
    },
    handleClickOutside(event) {
      if (!this.$refs.menuContainer.contains(event.target)) {
        for (const key in this.collapse) {
          this.collapse[key] = false;
        }
      }
    },
    favoritos() {

      if (this.usuario.id) {
        this.filterFavoritos = !this.filterFavoritos
        this.filterLotes()
      } else {
        this.$toast.open({
          message: 'Você precisa estar logado para filtrar os favoritos!',
          type: 'error',
        });
      }

    },
    clearFilters() {
      this.search = '';
      this.cidades = [];
      this.estados = [];
      this.categorias = [];
      this.tipos = [];
      this.valores = {min: '', max: ''};
      this.filterFavoritos = false;
      sessionStorage.removeItem('filtro-saladisputa');

      this.$parent.lotes = this.ordenarLotesPorSequencia(this.$parent.lotesOriginais);

      this.setFilters();
    },
    setFilters() {
      this.$parent.lotes.forEach((lote) => {
        if (lote.vistoria.length > 0) {
          const tipo = lote.vistoria[0].nm_categoria;
          const categoria = lote.vistoria[0].nm_subcategoria;

          const iCidade = lote.vistoria[0].i_nm_cidade;
          const eCidade = lote.vistoria[0].e_nm_cidade;
          const vCidade = lote.vistoria[0].v_nm_cidade;

          const iEstado = lote.vistoria[0].i_nm_estado;
          const eEstado = lote.vistoria[0].e_nm_estado;
          const vEstado = lote.vistoria[0].v_nm_estado;

          if (!this.filterTipos.includes(tipo)) this.filterTipos.push(tipo);
          if (!this.filterCategorias.includes(categoria)) this.filterCategorias.push(categoria);

          if (iCidade) {
            if (!this.filterCidades.includes(iCidade)) this.filterCidades.push(iCidade);
          }
          if (eCidade) {
            if (!this.filterCidades.includes(eCidade)) this.filterCidades.push(eCidade);
          }
          if (vCidade) {
            if (!this.filterCidades.includes(vCidade)) this.filterCidades.push(vCidade);
          }

          if (iEstado) {
            if (!this.filterEstados.includes(iEstado)) this.filterEstados.push(iEstado);
          }
          if (eEstado) {
            if (!this.filterEstados.includes(eEstado)) this.filterEstados.push(eEstado);
          }
          if (vEstado) {
            if (!this.filterEstados.includes(vEstado)) this.filterEstados.push(vEstado);
          }
        }
      });

      this.filterTipos.sort();
      this.filterCategorias.sort();
      this.filterCidades.sort();
      this.filterEstados.sort();
    },
    filterLotes(callback = null) {
      this.$nextTick(() => {
        this.aplicarFiltrosNosLotes();

        this.$parent.paginator.countLote = this.$parent.lotes.length;

        this.$parent.saladisputa.observaLotesStatusLance(this.$parent.lotes);
        this.$parent.saladisputa.configuraFavoritos();
        this.$parent.saladisputa.configuraVisitas();
        this.$parent.actionSeguir();

        if (typeof callback === 'function') {
          callback();
        }
      });
    },
    aplicarFiltrosNosLotes() {
      const filtros = {
        search: this.search,
        tipos: this.tipos,
        categorias: this.categorias,
        estados: this.estados,
        cidades: this.cidades,
        valores: this.valores,
        filterFavoritos: this.filterFavoritos,
      };

      let filtrados = Array.isArray(this.$parent.lotesOriginais)
        ? this.$parent.lotesOriginais.slice()
        : [];

      if (filtros.valores && filtros.valores.min) {
        filtrados = filtrados.filter(function (lote) {
          return parseInt(lote.vl_lanceinicial) >= parseInt(filtros.valores.min);
        });
      }

      if (filtros.valores && filtros.valores.max) {
        filtrados = filtrados.filter(function (lote) {
          return parseInt(lote.vl_lanceinicial) <= parseInt(filtros.valores.max);
        });
      }

      if (Array.isArray(filtros.cidades) && filtros.cidades.length > 0) {
        filtrados = filtrados.filter(function (lote) {
          if (!lote.vistoria || !lote.vistoria[0]) return false;
          const v = lote.vistoria[0];
          return (
            (v.i_nm_cidade && filtros.cidades.indexOf(v.i_nm_cidade) !== -1) ||
            (v.e_nm_cidade && filtros.cidades.indexOf(v.e_nm_cidade) !== -1) ||
            (v.v_nm_cidade && filtros.cidades.indexOf(v.v_nm_cidade) !== -1)
          );
        });
      }

      if (Array.isArray(filtros.estados) && filtros.estados.length > 0) {
        filtrados = filtrados.filter(function (lote) {
          if (!lote.vistoria || !lote.vistoria[0]) return false;
          const v = lote.vistoria[0];
          return (
            (v.i_nm_estado && filtros.estados.indexOf(v.i_nm_estado) !== -1) ||
            (v.e_nm_estado && filtros.estados.indexOf(v.e_nm_estado) !== -1) ||
            (v.v_nm_estado && filtros.estados.indexOf(v.v_nm_estado) !== -1)
          );
        });
      }

      if (Array.isArray(filtros.categorias) && filtros.categorias.length > 0) {
        filtrados = filtrados.filter(function (lote) {
          if (!lote.vistoria || !lote.vistoria[0]) return false;
          return filtros.categorias.indexOf(lote.vistoria[0].nm_subcategoria) !== -1;
        });
      }

      if (Array.isArray(filtros.tipos) && filtros.tipos.length > 0) {
        filtrados = filtrados.filter(function (lote) {
          if (!lote.vistoria || !lote.vistoria[0]) return false;
          return filtros.tipos.indexOf(lote.vistoria[0].nm_categoria) !== -1;
        });
      }

      if (filtros.search) {
        const termoNormalizado = this.normalizarTexto(filtros.search);
        filtrados = filtrados.filter((lote) => {
          const tituloNormalizado = this.normalizarTexto(lote.nm_titulo || "");
          const descricaoNormalizada = this.normalizarTexto(lote.nm_descricao || "");

          const termosArray = termoNormalizado.split(/\s+/);

          return termosArray.every(termo =>
            tituloNormalizado.includes(termo) ||
            descricaoNormalizada.includes(termo)
          );
        });
      }

      if (filtros.filterFavoritos) {
        filtrados = filtrados.filter(function (lote) {
          return lote.is_favorito;
        });
      }

      this.$parent.lotes = this.ordenarLotesPorSequencia(filtrados);

      sessionStorage.setItem('filtro-saladisputa', JSON.stringify(filtros));
    },
    atualizarCategoriasPorTipo() {
      // Limpa as categorias existentes
      this.filterCategorias = [];

      if (!this.tipos.length) return;

      let categoriasDisponiveis = new Set();

      this.$parent.lotesOriginais.forEach(lote => {
        if (lote.vistoria && lote.vistoria.length > 0) {
          if (this.tipos.includes(lote.vistoria[0].nm_categoria)) {
            categoriasDisponiveis.add(lote.vistoria[0].nm_subcategoria);
          }
        }
      });

      this.filterCategorias = Array.from(categoriasDisponiveis).sort();
    },

    atualizarCidadesPorEstado() {
      this.cidadesPorEstado = {};

      this.$parent.lotes.forEach(lote => {
        if (lote.vistoria && lote.vistoria.length > 0) {
          const vistoria = lote.vistoria[0];

          if (vistoria.i_nm_cidade && vistoria.i_nm_estado) {
            if (!this.cidadesPorEstado[vistoria.i_nm_estado]) {
              this.cidadesPorEstado[vistoria.i_nm_estado] = new Set();
            }
            this.cidadesPorEstado[vistoria.i_nm_estado].add(vistoria.i_nm_cidade);
          }

          if (vistoria.e_nm_cidade && vistoria.e_nm_estado) {
            if (!this.cidadesPorEstado[vistoria.e_nm_estado]) {
              this.cidadesPorEstado[vistoria.e_nm_estado] = new Set();
            }
            this.cidadesPorEstado[vistoria.e_nm_estado].add(vistoria.e_nm_cidade);
          }

          if (vistoria.v_nm_cidade && vistoria.v_nm_estado) {
            if (!this.cidadesPorEstado[vistoria.v_nm_estado]) {
              this.cidadesPorEstado[vistoria.v_nm_estado] = new Set();
            }
            this.cidadesPorEstado[vistoria.v_nm_estado].add(vistoria.v_nm_cidade);
          }
        }
      });

      Object.keys(this.cidadesPorEstado).forEach(estado => {
        this.cidadesPorEstado[estado] = Array.from(this.cidadesPorEstado[estado]).sort();
      });
    },
    atualizarEstadosPorCategoria() {
      this.estadosPorCategoria = {};

      this.$parent.lotes.forEach(lote => {
        if (lote.vistoria && lote.vistoria.length > 0) {
          const tipo = lote.vistoria[0].nm_categoria;

          if (!this.estadosPorCategoria[tipo]) {
            this.estadosPorCategoria[tipo] = {};
          }

          if (lote.vistoria[0].i_nm_estado) {
            if (!this.estadosPorCategoria[tipo][lote.vistoria[0].i_nm_estado]) {
              this.estadosPorCategoria[tipo][lote.vistoria[0].i_nm_estado] = new Set();
            }
          }

          if (lote.vistoria[0].e_nm_estado) {
            if (!this.estadosPorCategoria[tipo][lote.vistoria[0].e_nm_estado]) {
              this.estadosPorCategoria[tipo][lote.vistoria[0].e_nm_estado] = new Set();
            }
          }

          if (lote.vistoria[0].v_nm_estado) {
            if (!this.estadosPorCategoria[tipo][lote.vistoria[0].v_nm_estado]) {
              this.estadosPorCategoria[tipo][lote.vistoria[0].v_nm_estado] = new Set();
            }
          }
        }
      });

      this.filterEstados = this.estadosFiltrados;
    }
  },
}
</script>

<style scoped>
.container_filter {
  min-width: 1260px;
  background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/jrleiloes/layout/images/filtro.png");
  object-fit: cover;
  background-repeat: no-repeat;
  max-width: 1200px;
  height: 90px;
  display: flex;
  align-items: center;
}

.container_filter-meireles {
  min-width: 1260px;
  background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/meirelesleiloes/layout/images/filtro.png");
  object-fit: cover;
  background-repeat: no-repeat;
  max-width: 1200px;
  height: 90px;
  display: flex;
  align-items: center;
}

.search-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  margin-top: 30px;
}

.search-box {
  display: flex;
  gap: 10px;
}

input.search-input {
  padding: 5px 11px;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 500;
  color: #707070;
  width: 247px;
}

.filters-container {
  display: flex;
  gap: 10px;
}

.filter-group {
  display: flex;
  gap: 10px;
}

.filter,
.filter-values,
.favorites-container,
.limpar-btn,
.buscar-btn {
  display: flex;
  align-items: center;
  padding: 5px 11px;
  background: #fff;
  border-radius: 5px;
  font-size: 15px;
  color: #707070;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s ease-in-out;
}

.filter:hover,
.filter-values:hover,
.favorites-container:hover,
.limpar-btn:hover {
  background: #ccc;
  transition: 0.2s ease-in-out;
}

.filter .filter-title,
.filter-values .filter-title,
.favorites-icon,
.limpar-btn {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-menu-values {
  position: absolute;
  top: 85px;
  background: #fff;
  opacity: 0.7;
  padding: 6px 12px;
  border-radius: 5px;
  z-index: 41;
  backdrop-filter: blur(5px);
}

#filter-menu-tipo,
#filter-menu-categoria,
#filter-menu-estado,
#filter-menu-cidade {
  position: absolute;
  top: 85px;
  background: #fff;
  opacity: 0.7;
  padding: 6px 12px;
  border-radius: 5px;
  z-index: 41;
  backdrop-filter: blur(5px);
}

.filter-menu-values {
  right: 240px;
  cursor: initial;
}

.value-inputs {
  display: flex;
  width: 376px;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.value-input {
  color: #1C2D47;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}

.value-input input {
  background: #ccc;
  width: 145px;
  border-radius: 5px;
  padding: 5px 11px;
}

.value-separator {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.separator-line {
  width: 20px;
  height: 3px;
  background: #1C2D47;
}

.separator-dot {
  background: #1C2D47;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-button-container {
  padding: 6px 12px;
  font-size: 13px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.filter-button {
  width: fit-content;
  background: #1C2D47;
  border-radius: 5px;
  padding: 5px 11px;
  margin-top: 10px;
  color: #fff;
}

.filter-options {
  max-height: 160px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  scrollbar-width: thin;
  scrollbar-color: #fff #ccc;
}

.filter-option {
  margin-right: 10px;
  color: #1C2D47;
  display: flex;
  align-items: center;
  gap: 5px;
}

.buscar-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #6ABA62;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buscar-btn:hover {
  background: #4c8647;
  transition: 0.2s ease-in-out;
}

.icon-arrow-down,
.icon-arrow-up {
  font-size: 13px;
}

.input-wrapper .icon-close {
  position: relative;
  background: #fff;
  font-size: 10px;
  padding: 5px;
  border-radius: 5px;
  color: #1c2d47;
  cursor: pointer;
  left: 3px;
}

.icon-close {
  font-size: 12px;
}

.icon-lupa {
  font-size: 18px;
  font-weight: 700;
}

.filter-alert {
  position: absolute;
  margin-top: 40px;
  right: 0;
  font-size: 12px;
  color: #fff;
  background-color: #333;
  border-radius: 4px;
  padding: 5px;
  opacity: 0.9;
  z-index: 10;
}

.filter.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.filter.disabled:hover {
  background: #fff;
}

@media (max-width: 1024px) {
  .filter-alert {
    right: 310px;
  }

  .container_filter {
    min-width: 685px;
    max-width: 1000px;
    height: 180px;
    background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/jrleiloes/layout/images/filtro-1024.png");
    display: flex;
    justify-content: center;
    background-position: center;
  }

  .container_filter-meireles {
    min-width: 685px;
    max-width: 1000px;
    height: 180px;
    background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/meirelesleiloes/layout/images/filtro-1024.png");
    display: flex;
    justify-content: center;
    background-position: center;
  }

  .search-container {
    flex-direction: column;
    gap: 10px;
    width: fit-content;
    margin-top: 40px;
  }

  .search-box {
    flex-direction: column;
  }

  input.search-input {
    width: 100%;
  }

  .filter-menu-values {
    top: 130px;
    opacity: 0.8;
    backdrop-filter: blur(5px);
  }

  #filter-menu-tipo,
  #filter-menu-categoria,
  #filter-menu-estado,
  #filter-menu-cidade {
    top: 132px;
    opacity: 0.8;
  }

  .filter-menu-values {
    right: 145px;
  }

  .input-wrapper .icon-close {
    position: absolute;
    left: auto;
    right: 185px;
    top: 80px;
    background: #ccc;
    transition: 0.2s ease-in-out;
  }

  .input-wrapper .icon-close:hover {
    background: #a1a1a1;
    transition: 0.2s ease-in-out;
    color: #fff;
  }
}

@media (max-width: 768px) {
  .filter-alert {
    right: 175px;
  }

  .filter-menu-values {
    right: 35px;
    top: 132px;
    opacity: 0.8;
  }

  .input-wrapper .icon-close {
    right: 58px;
  }
}

@media (max-width: 435px) {
  .filter-alert {
    right: 25px;
    font-size: 10px;
    white-space: nowrap;
  }

  .container_filter {
    min-width: 354px;
    max-width: 354px;
    height: 250px;
    background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/jrleiloes/layout/images/filtro-435.png");
  }

  .container_filter-meireles {
    min-width: 354px;
    max-width: 354px;
    height: 250px;
    background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/meirelesleiloes/layout/images/filtro-435.png");
  }

  .search-container {
    width: 100%;
  }

  .search-box {
    width: 100%;
  }

  input.search-input {
    width: 100%;
    font-size: 13px;
  }

  .filters-container {
    flex-direction: column;
  }

  .filter-group {
    width: 100%;
  }

  .filter-title,
  .favorites-icon {
    justify-content: space-between;
    width: 100%;
  }

  .filter,
  .filter-values,
  .favorites-container,
  .limpar-btn,
  .buscar-btn {
    width: 50%;
  }

  .filter,
  .filter-values,
  .favorites-container,
  .limpar-btn span,
  .buscar-btn span {
    font-size: 13px;
  }

  .limpar-btn,
  .buscar-btn {
    justify-content: space-between;
  }

  .icon-lupa {
    font-size: 16px;
  }

  #filter-menu-tipo,
  #filter-menu-categoria {
    top: 125px;
  }

  #filter-menu-estado,
  #filter-menu-cidade {
    top: 165px;
  }

  .filter-menu-values {
    right: -10px;
    cursor: auto;
    top: 254px;
    opacity: 1;
  }

  .input-wrapper .icon-close {
    position: absolute;
    left: initial;
    top: 79px;
    right: 60px;
    background: #ccc;
  }
}

@media (max-width: 375px) {
  .container_filter {
    min-width: 300px;
    max-width: 354px;
    height: 250px;
    background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/jrleiloes/layout/images/filtro-375.png");
  }

  .container_filter-meireles {
    min-width: 300px;
    max-width: 354px;
    height: 250px;
    background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/meirelesleiloes/layout/images/filtro-375.png");
  }

  .filter-alert {
    right: 8px;
    font-size: 10px;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Filtro.vue